import React from 'react';

const About = () => (
  <section id="about" className="section-stone">
    <h2 style={{letterSpacing: '5px', textTransform: 'uppercase', fontSize: '0.9rem'}}>The Approach</h2>
    <p style={{maxWidth: '800px', fontSize: '1.8rem', fontWeight: '300', textAlign: 'center'}}>
      Concentrated focus on high-stakes litigation and asset protection. Clarity in complexity.
    </p>
  </section>
);

export default About;